<template>
  <v-menu min-width="400" offset-y>
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        elevation="0"
        class="ml-4"
        v-on="on"
      >
        Фильтр по полям
      </v-btn>
    </template>
    <v-list>
      <v-subheader>Фильтры по полям</v-subheader>
      <v-list-item v-for="item in filters" :key="item.id" @click.stop.prevent="">
        <form
          v-if="['double', 'int'].includes(item.type)"
          autocomplete="off"
          style="width: 100%"
          class="d-flex align-center flex-row"
        >
          <div class="d-flex">
            <v-text-field
              v-model="item.selectedValues[0]"
              class="mr-4"
              :label="`${item.name} (Мин.)`"
              hide-details
            />
            <v-text-field
              v-model="item.selectedValues[1]"
              class="ml-4"
              :label="`${item.name} (Макс.)`"
              hide-details
            />
          </div>
        </form>

        <form v-if="item.type === 'text'" autocomplete="off" style="width: 100%;">
          <v-text-field
            v-model="item.selectedValues[0]"
            :label="item.name"
            :disabled="isLoading"
            hide-details
          />
        </form>
        <v-select
          v-if="item.type === 'select'"
          v-model="item.selectedValues[0]"
          :items="item.preparedValues"
          :label="item.name"
          :disabled="isLoading"
          hide-details
        />
      </v-list-item>
      <v-list-item>
        <v-btn
          class="success"
          small
          style="width: 100%"
          :disabled="isLoading"
          @click="save"
        >
          Применить фильтры
        </v-btn>
      </v-list-item>
      <v-list-item>
        <v-btn
          text
          small
          style="width: 100%"
          :disabled="isLoading"
          @click="reset"
        >
          Сбросить фильтры
        </v-btn>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>

export default {
  name: 'geometry-properties-filter',
  props: {
    fields: {
      required: true,
      type: Array,
    },
    isLoading: Boolean,
  },
  data: () => ({
    filters: [],
  }),
  async created() {
    this.filters = this.fields.map(_ => ({
      ..._,
      selectedValues: ['', ''],
    }));

    this.original = JSON.parse(JSON.stringify(this.filters));
  },
  methods: {
    reset() {
      this.filters = JSON.parse(JSON.stringify(this.original));
      this.save();
    },
    save() {
      if (JSON.stringify(this.filters) === JSON.stringify(this.original)) {
        this.$emit('change', null);
        return;
      }

      const props = {};

      this.filters.forEach(filter => {
        if (!filter.selectedValues[0] && !filter.selectedValues[1]) return;
        if (['double', 'int'].includes(filter.type) && (!filter.selectedValues[0] || !filter.selectedValues[1])) return;

        props[filter.id] = {
          values: filter.selectedValues,
        };
      });

      this.$emit('change', props);
    },
  },
};
</script>

<style scoped>

</style>
